import { Features } from '@wix/ambassador-bookings-v2-bookings-settings/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { BookingsAPI } from '../../api/BookingsApi';
import type { FilterFieldDescriptor } from '../../components/BookOnline/Widget/Filters/types';
import { ServiceListContext } from '../../context/createServiceListContext';
import { enrichServices } from '../../utils/services/services';
import { WidgetViewModel } from '../../viewModel/viewModel';

export type SearchServicesAction = (
  filterValues: Record<string, any>,
  filterFields: FilterFieldDescriptor[],
) => Promise<void>;

export const createSearchServicesAction =
  ({
    widgetViewModel,
    bookingsApi,
    flowAPI,
    setProps,
    serviceListContext,
    activeFeatures,
    isPricingPlanInstalled,
  }: {
    widgetViewModel: WidgetViewModel;
    bookingsApi: BookingsAPI;
    flowAPI: ControllerFlowAPI;
    setProps: Function;
    serviceListContext: ServiceListContext;
    activeFeatures: Features;
    isPricingPlanInstalled: boolean;
  }): SearchServicesAction =>
  async (filterValues: Record<string, any>, filterFields: FilterFieldDescriptor[]) => {
    try {
      const conditions: Record<string, any>[] = [];
      for (const field of filterFields) {
        const rawValue = filterValues[field.key];
        if (rawValue === undefined) {
          continue;
        }
        const apiKey = `extendedFields.namespaces.${field.namespace}.${field.key}`;
        let value = rawValue;
        if (field.type === 'date-time' && rawValue?.date) {
          const time = rawValue.time || '00:00';
          value = `${rawValue.date}T${time}:00`;
        }

        if (field.type === 'array' && Array.isArray(value)) {
          conditions.push({ [apiKey]: { $hasSome: value } });
        } else {
          const isTextType = field.type === 'string' || field.type === 'long-text';
          const condition = isTextType && value
            ? { [apiKey]: { $in: [value] } }
            : { [apiKey]: value };
          conditions.push(condition);
        }
      }
      const filter = conditions.length ? { $and: conditions } : {};
      const rawServices = await bookingsApi.searchServices(filter);
      const enrichedResults = await enrichServices({
        flowAPI,
        activeFeatures,
        isPricingPlanInstalled,
        services: rawServices,
        isAnywhereFlow: serviceListContext.isAnywhereFlow,
      });
      widgetViewModel.services = enrichedResults;
      setProps({ widgetViewModel: { ...widgetViewModel } });
    } catch (error) {
      console.error('searchServices failed:', error);
    }
  };
